// require('es6-promise').polyfill()

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import App from './App';
import router from './router';
import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';
import { Skeleton } from 'vant';
Vue.use(Skeleton);
import promise from 'es6-promise';
promise.polyfill();
import cookie from './auth';
Vue.prototype.$cookie = cookie;
Vue.prototype.$getParams = params => {
  let urlSliptArray = params.split("?");
  if (urlSliptArray.length < 2) {
    return {}
  }
  let str = decodeURIComponent(urlSliptArray[1]);
  // let arr = str.split("?")[1].split("&"); //先通过？分解得到？后面的所需字符串，再将其通过&分解开存放在数组里
  let paramsStr = str.split("&"); //先通过？分解得到？后面的所需字符串，再将其通过&分解开存放在数组里
  let obj = {};
  for (let i of paramsStr) {
    let a = (i.replace(/=/, ',')).split(',')
    obj[a[0]] = a[1]; //对数组每项用=分解开，=前为对象属性名，=后为属性值
  }
  return obj
};
//对比版本号 1 version1>version2  -1 version1<version2  0 version1=version2
Vue.prototype.$compareVersion = (version1, version2) => {
  let arr1 = version1.split('.').map(e => e * 1);
  let arr2 = version2.split('.').map(e => e * 1);
  let length = Math.max(arr1.length, arr2.length)
  for (let i = 0; i < length; i++) {
    if ((arr1[i] || 0) > (arr2[i] || 0)) return 1
    if ((arr1[i] || 0) < (arr2[i] || 0)) return -1
  }
  return 0
};

Vue.use(VueClipboard)

Vue.config.productionTip = false;
Vue.config.ignoredElements = ['wx-open-launch-weapp'];
Vue.config.ignoredElements = ['wx-open-launch-app'];


new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})

import baseFunc from './base'
Vue.use(baseFunc);


import './styles/base.css'
import './permission' // permission control
import './vue-touch'




import axios from 'axios' // 1、在这里引入axios
// import { mockXHR } from '../mock'
// if (process.env.NODE_ENV === ‘production’) {
// mockXHR()
// }

axios.defaults.timeout = 30000;

//http request 拦截器
axios.interceptors.request.use(config => {
  config.headers.appVersion = '1.0';
  config.headers.deviceVersion = getOs() + ',' + validB();
  config.headers.deviceModel = navigator.platform;
  config.headers.device = '6';
  config.headers.channel = 'h5';


  //针对积分抽奖、每日抽奖修改headers头
  if (router.app._route.name == 'integralDraw' || router.app._route.name == 'everyDayDraws') {
    if (router.app._route.query.data) {
      let routerData = JSON.parse(decodeURIComponent(router.app._route.query.data))
      config.headers.device = routerData.device;
      config.headers.channel = routerData.channel;
      config.headers.deviceVersion = routerData.deviceVersion;
      config.headers.deviceModel = routerData.deviceModel;
      config.headers.appVersion = routerData.appVersion;
    } else {
      if (router.app._route.query.token && router.app._route.query.users_id) {
        config.headers.device = router.app._route.query.device;
        config.headers.channel = router.app._route.query.channel;
        config.headers.deviceVersion = router.app._route.query.deviceVersion;
        config.headers.deviceModel = router.app._route.query.deviceModel;
        config.headers.appVersion = router.app._route.query.appVersion;
      } else {
        let routeData = Vue.prototype.$getParams(window.location.href);
        config.headers.device = routeData.device;
        config.headers.channel = routeData.channel;
        config.headers.deviceVersion = routeData.deviceVersion;
        config.headers.deviceModel = routeData.deviceModel;
        config.headers.appVersion = routeData.appVersion;
      }
    }
  }else if(router.app._route.name=='renewals'){// 针对折扣卡开通页请求修改headers头
    config.headers.device = '3';
  }
  if (Vue.prototype.getBiguoUserInfo() && Vue.prototype.getBiguoUserInfo().token) {
    config.headers.token = Vue.prototype.getBiguoUserInfo().token
  }
  return config;
}, error => {
  return Promise.reject(error);
});
//http response 拦截器
axios.interceptors.response.use(response => {
  if (response.data.result_code === -1 || response.data.code === -1) {
    vant.Toast('登录信息失效，需要重新登录');
    Vue.prototype.removeBiguoUserInfo()
    // location.reload(); // 为了重新实例化vue-router对象 避免bug
  } else if (response.data.result_code === 0 || response.data.code === 0) {
    console.log(response)
    if(response.config.url!='https://www.biguotk.com/api/yami_refund'){
      vant.Toast(response.data.result_info || response.data.info || '数据错误');
    }
  }

  return response;
}, error => {
  console.log(error, '500')
  vant.Toast(error.message);
  return Promise.reject(error)
})



Vue.prototype.$axios = axios; // 2、在vue中使用axios
//提取操作系统和浏览器
function validB() {
  var u_agent = navigator.userAgent;
  var B_name = "Failed to identify the browser";
  if (u_agent.indexOf("Firefox") > -1) {
    B_name = "Firefox";
  } else if (u_agent.indexOf("Chrome") > -1) {
    B_name = "Chrome";
  } else if (u_agent.indexOf("MSIE") > -1 && u_agent.indexOf("Trident") > -1) {
    B_name = "IE(8-10)";
  }
  return B_name;
}

//获取操作系统
function getOs() {
  var sUserAgent = navigator.userAgent;
  var isWin = (navigator.platform == "Win32") || (navigator.platform == "Windows");
  var isMac = (navigator.platform == "Mac68K") || (navigator.platform == "MacPPC") || (navigator.platform == "Macintosh") || (navigator.platform == "MacIntel");
  if (isMac) return "MacOS";

  var isUnix = (navigator.platform == "X11") && !isWin && !isMac;
  if (isUnix) return "Unix";

  var isLinux = (String(navigator.platform).indexOf("Linux") > -1);
  if (isLinux) return "Linux";

  if (isWin) {
    var isWin2K = sUserAgent.indexOf("Windows NT 5.0") > -1 || sUserAgent.indexOf("Windows 2000") > -1;
    if (isWin2K) return "Windows2000";

    var isWinXP = sUserAgent.indexOf("Windows NT 5.1") > -1 || sUserAgent.indexOf("Windows XP") > -1;
    if (isWinXP) return "WindowsXP";

    var isWin2003 = sUserAgent.indexOf("Windows NT 5.2") > -1 || sUserAgent.indexOf("Windows 2003") > -1;
    if (isWin2003) return "Windows2003";

    var isWinVista = sUserAgent.indexOf("Windows NT 6.0") > -1 || sUserAgent.indexOf("Windows Vista") > -1;
    if (isWinVista) return "Windows Vista";

    var isWin7 = sUserAgent.indexOf("Windows NT 6.1") > -1 || sUserAgent.indexOf("Windows 7") > -1;
    if (isWin7) return "Windows7";

    var isWin10 = sUserAgent.indexOf("Windows NT 10.0") > -1 || sUserAgent.indexOf("Windows 10") > -1;
    if (isWin10) return "Windows10";
  }
}









// WEBPACK FOOTER //
// ./src/main.js